/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useSponsorsList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const SponsorSelect = ({ placeholder = 'Type the name of sponsor...', ...props }) => (
  <SearchableEntitySelect placeholder={placeholder} useList={useSponsorsList} {...props} />
);

export default SponsorSelect;
